// extracted by mini-css-extract-plugin
export default {"button":"FollowButtonControlled_button__GhnOg","buttonHideIcons":"FollowButtonControlled_buttonHideIcons__mqCRD"};